import { Check, ChevronDown } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "./ui/popover";

// Compact multi-select: trigger shows a summary, popover lists toggleable options.
export function MultiSelect({ options, value = [], onChange, placeholder = "Select…", testid }) {
  const selected = Array.isArray(value) ? value : value ? [value] : [];
  const toggle = (opt) => {
    if (selected.includes(opt)) onChange(selected.filter((v) => v !== opt));
    else onChange([...selected, opt]);
  };

  return (
    <Popover>
      <PopoverTrigger asChild>
        <button
          type="button"
          role="combobox"
          data-testid={testid}
          className="flex h-8 w-full items-center justify-between rounded-md border border-input bg-transparent px-3 text-sm text-left"
        >
          <span className={`truncate ${selected.length ? "" : "text-muted-foreground"}`}>
            {selected.length ? `${selected.length} selected` : placeholder}
          </span>
          <ChevronDown className="h-4 w-4 opacity-50 shrink-0" />
        </button>
      </PopoverTrigger>
      <PopoverContent className="w-[260px] p-1" align="start">
        <div className="max-h-64 overflow-y-auto slim-scroll">
          {options.map((opt) => {
            const on = selected.includes(opt);
            return (
              <button
                key={opt}
                type="button"
                onClick={() => toggle(opt)}
                data-testid={`${testid}-option-${opt.replace(/[^a-z0-9]+/gi, "-").toLowerCase()}`}
                className="flex w-full items-center gap-2 rounded-sm px-2 py-1.5 text-sm hover:bg-accent transition-colors text-left"
              >
                <span className={`flex h-4 w-4 items-center justify-center rounded border ${on ? "bg-primary border-primary text-primary-foreground" : "border-input"}`}>
                  {on && <Check className="h-3 w-3" />}
                </span>
                <span className="truncate">{opt}</span>
              </button>
            );
          })}
        </div>
      </PopoverContent>
    </Popover>
  );
}
